import { format, parse, differenceInCalendarDays } from 'date-fns';

export const mapValueToId = (data = [], mapKey) => {
  if(Array.isArray(data) && data.length){
    return data.map((value, index) => ({...value, id: value[mapKey] || index}))
  }
  return data;
}

export const getConstDbFormat = (date = new Date()) => {
  return `${date.getDate().toString().padStart(2, '0')}-${(date.getMonth()+1).toString().padStart(2, '0')}-${date.getFullYear()}` 
};

export const getBookingStatus = (booking) => {
  let status = null;
  const bookingStartDate = parse(booking?.fromDate, 'dd-MM-yyyy', new Date());
  const bookingEndDate = parse(booking?.toDate, 'dd-MM-yyyy', new Date());
  const today = new Date();
  if(booking){
    if(booking?.cancelled){
      status = "Cancelled";
    } else if(differenceInCalendarDays(bookingStartDate, today) < 0 && differenceInCalendarDays(bookingEndDate, today) < 0) {
      status = "Completed";
    } else if(differenceInCalendarDays(bookingStartDate, today) > 0 ) {
      status = "Upcoming";
    } else{
      status = "Ongoing";
      if(
        // differenceInCalendarDays(bookingStartDate, today) === 0 && 
        // differenceInCalendarDays(bookingStartDate, bookingEndDate) === 0 && 
        booking?.library?.hourlyBookingsEnabled
      ) {
        const bookingStartTime = parseFloat(booking?.fromTime);
        const bookingEndTime = parseFloat(booking?.toTime);
        const currentHour = new Date().getHours();
        if(bookingStartTime < currentHour && bookingEndTime < currentHour) {
          status = "Completed";
        } else if(bookingStartTime > currentHour) {
          status = "Upcoming";
        }
      }
    }
  }
  return status;
};

export function getDBDateFormat(date) {
  return date ? format(date, 'dd-MM-yyyy') : date;
}

export const getFormattedDate = (filterDates) => {
  const [fromDate, toDate] = filterDates;
  if((fromDate && !toDate) || (fromDate && toDate && getDBDateFormat(fromDate) === getDBDateFormat(toDate))) {
    return `${format(fromDate,'dd MMM, yyyy')}`;
  } else if(fromDate && toDate){
    return `${format(fromDate,'dd MMM, yyyy')} - ${format(toDate,'dd MMM, yyyy')}`;
  } else {
    return 'Select Date';
  }
}

export const buildTableDataAndColumns = (columns=[], apiData=[]) => {
  const tableData=[];
  const tableColumns = [];
  columns.forEach((column, index) => {
    // Column
    const col = {
      // id: index,
      // defaultFlex: 1,
      header: column.name,
      name: column?.dataKey || column?.key,
      ...(column?.columnOptions || {})
    };
    tableColumns.push(col);
  });

  const formatValue = (val) => {
    if(Array.isArray(val)){
      return val.filter((val) => (typeof val=== 'string' || typeof val=== 'number')).join(', ');
    }
    if(typeof val === 'object'){
      return Object.values(val).filter((val) => typeof val=== 'string').join(', ');
    }
    return val.toString();
  };

  // Build row data
  apiData.forEach((row, i) => {
    const rowObj = {};
    columns.forEach((col) => {
      const [keyName, childKeyName] = col.key.split('.');
      if(keyName && childKeyName){
        const rowkeyData = row[keyName][childKeyName] || '';
        rowObj[col?.dataKey || col?.key] = formatValue(rowkeyData); 
      }else if(keyName){
        const rowkeyData = row[keyName] || '';
        rowObj[col?.dataKey || col?.key] = formatValue(rowkeyData); 
      }
    });
    tableData.push({rdg_row_id: i+1, ...row, ...rowObj});
  });
  return {columns: tableColumns, dataSource: tableData};
}

export function tConv24(time24) {
  var ts = time24;
  var H = +ts.substr(0, 2);
  var h = (H % 12) || 12;
  h = (h < 10)?("0"+h):h;  // leading 0 at the left for 1 digit hours
  var ampm = H < 12 ? " AM" : " PM";
  ts = h + ts.substr(2, 3) + ampm;
  return ts;
};
